(() => {
  if (customElements.get('lc-header-typing')) return;

  class LCHeaderTyping extends HTMLElement {
    connectedCallback() {
      this.targets = document.querySelectorAll(
        '[data-lc-header-typing], [data-lc-header-typing-input]'
      );

      if (!this.targets.length) return;

      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.targets.forEach(target => {
        const terms = (target.dataset.terms || '')
          .split('|')
          .map(term => term.trim())
          .filter(Boolean);

        if (!terms.length) return;

        if (reduceMotion) {
          this.write(target, terms[0]);
          return;
        }

        this.animate(target, terms);
      });
    }

    write(target, value) {
      if (target.matches('input')) {
        if (document.activeElement !== target && target.value === '') {
          target.placeholder = value;
        }
      } else {
        target.textContent = value;
      }
    }

    animate(target, terms) {
      let termIndex = 0;
      let characterIndex = 0;
      let deleting = false;

      const tick = () => {
        if (!target.isConnected) return;

        const term = terms[termIndex];
        characterIndex += deleting ? -1 : 1;
        this.write(target, term.slice(0, characterIndex));

        let delay = deleting ? 42 : 78;

        if (!deleting && characterIndex === term.length) {
          deleting = true;
          delay = 1500;
        } else if (deleting && characterIndex === 0) {
          deleting = false;
          termIndex = (termIndex + 1) % terms.length;
          delay = 260;
        }

        window.setTimeout(tick, delay);
      };

      tick();
    }
  }

  customElements.define('lc-header-typing', LCHeaderTyping);

  const typingController = document.createElement('lc-header-typing');
  document.body.appendChild(typingController);
})();
